const AppFieldSubtitleConfig = {
    fontColor: {
        gray: "gray",
        black: "black"
    },
    fontStyle: {
        italic: "italic",
        bold: "bold",
        normal: "normal"
    }
}

export default AppFieldSubtitleConfig